/* ==========================================================================
   Supplier Code of Ethics Page Component
   Authentic Multilingual Implementation for JALUD Embedded s.r.o.
   Covers CS, DE, EN, ES, PT, AR (with strict RTL support)
   ========================================================================== */

import { getLocale } from '../locales/i18n.js';

const ethicsData = {
  cs: {
    title: 'Etický kodex pro dodavatele',
    eyebrow: 'FIREMNÍ ODPOVĚDNOST A UDRŽITELNOST',
    subtitle: 'Etické zásady a standardy odpovědného podnikání pro dodavatele a obchodní partnery společnosti JALUD Embedded s.r.o.',
    pdfBtn: 'Stáhnout PDF',
    pdfUrl: '/docs/legal/ETICKY_KODEX_DODAVATELE.pdf',
    intro: 'JALUD EMBEDDED, s.r.o. (dále JLD) dbá na sociální a obchodní zodpovědnost, s cílem dlouhodobě vytvářet hodnoty. Součástí tohoto přístupu je zapojení obchodních partnerů do strategie udržitelnosti.',
    sections: [
      {
        num: '1',
        title: 'Zacházení se zaměstnanci',
        text: 'JLD od obchodních partnerů požaduje dodržování právních předpisů a standardů OSN a ILO (Mezinárodní organizace práce), zákaz využívání dětské práce, rovnost příležitostí bez diskriminace, odmítání otroctví a nucené práce, respekt k odborům a zájmovým skupinám, dodržování právních předpisů v oblasti mezd a pracovní doby.'
      },
      {
        num: '2',
        title: 'Bezpečnost a ochrana zdraví',
        text: 'JLD požaduje, aby dodavatelé zajistili bezpečné pracovní prostředí, dodržovali legislativu o BOZP a přijali preventivní opatření na ochranu zdraví.'
      },
      {
        num: '3',
        title: 'Ochrana životního prostředí',
        text: 'JLD od obchodních partnerů očekává dodržování příslušných zákonů a nařízení, stejně jako i efektivní využívání zdrojů a bezpečných materiálů.'
      },
      {
        num: '4',
        title: 'Při jednání v obchodním prostředí',
        text: 'JLD prosazuje netolerování úplatků a manipulace, přijímání darů a pozvánek pouze v přiměřené hodnotě, rozhodování na základě objektivních kritérií, dodržování pravidel hospodářské soutěže a součinnost v boji proti praní špinavých peněz.'
      },
      {
        num: '5',
        title: 'Ochrana informací',
        text: 'Dodavatelé JLD jsou povinni chránit důvěrné informace a obchodní tajemství, zpracovávat osobní data v souladu s právními předpisy a využívat informace pouze k oprávněným účelům.'
      },
      {
        num: '6',
        title: 'Vztahy s dodavateli',
        text: 'JLD požaduje, aby její partneři přenesli zásady tohoto etického kodexu na své subdodavatele.'
      },
      {
        num: '7',
        title: 'Dodržování kodexu',
        text: 'Porušení zásad tohoto etického kodexu může vést k přehodnocení obchodního vztahu s dodavateli JLD s.r.o., ukončení spolupráce a případné náhradě škody.'
      },
      {
        num: '8',
        title: 'Oznámení porušení',
        text: 'Obchodní partneři jsou povinni hlásit podezření na porušení kodexu nebo právních předpisů oprávněnému zástupci JALUD EMBEDDED, s.r.o.'
      }
    ]
  },
  de: {
    title: 'Ethikkodex – Lieferanten',
    eyebrow: 'UNTERNEHMENSVERANTWORTUNG & NACHHALTIGKEIT',
    subtitle: 'Ethische Grundsätze und Standards für Lieferanten und Geschäftspartner der JALUD Embedded s.r.o.',
    pdfBtn: 'PDF herunterladen',
    pdfUrl: '/docs/legal/ETHIKKODEX_LIEFERANTEN.pdf',
    intro: 'JALUD EMBEDDED, s.r.o. (im Folgenden JLD) legt großen Wert auf soziale und geschäftliche Verantwortung, mit dem Ziel, langfristig Werte zu schaffen. Ein Bestandteil dieses Ansatzes ist die Einbeziehung von Geschäftspartnern in die Nachhaltigkeitsstrategie.',
    sections: [
      {
        num: '1',
        title: 'Umgang mit Mitarbeitenden',
        text: 'JLD verlangt von seinen Geschäftspartnern die Einhaltung der gesetzlichen Vorschriften sowie der Standards der UN und der ILO (Internationale Arbeitsorganisation), das Verbot von Kinderarbeit, Chancengleichheit ohne Diskriminierung, die Ablehnung von Sklaverei und Zwangsarbeit, die Achtung von Gewerkschaften und Interessenvertretungen sowie die Einhaltung gesetzlicher Vorschriften zu Löhnen und Arbeitszeiten.'
      },
      {
        num: '2',
        title: 'Sicherheit und Gesundheitsschutz',
        text: 'JLD fordert von seinen Lieferanten, ein sicheres Arbeitsumfeld zu gewährleisten, die Arbeitsschutzvorschriften einzuhalten und vorbeugende Maßnahmen zum Schutz der Gesundheit zu ergreifen.'
      },
      {
        num: '3',
        title: 'Umweltschutz',
        text: 'JLD erwartet von seinen Geschäftspartnern die Einhaltung der einschlägigen Gesetze und Verordnungen sowie den effizienten Einsatz von Ressourcen und sicheren Materialien.'
      },
      {
        num: '4',
        title: 'Verhalten im geschäftlichen Umfeld',
        text: 'JLD setzt die Null-Toleranz gegenüber Bestechung und Manipulation durch, akzeptiert Geschenke und Einladungen nur in angemessenem Wert, trifft Entscheidungen auf Grundlage objektiver Kriterien, fordert die Einhaltung der Wettbewerbsregeln und die Mitwirkung im Kampf gegen Geldwäsche.'
      },
      {
        num: '5',
        title: 'Informationsschutz',
        text: 'Die Lieferanten von JLD sind verpflichtet, vertrauliche Informationen und Geschäftsgeheimnisse zu schützen, personenbezogene Daten gemäß den gesetzlichen Vorschriften zu verarbeiten und Informationen ausschließlich für rechtmäßige Zwecke zu verwenden.'
      },
      {
        num: '6',
        title: 'Beziehungen zu Unterlieferanten',
        text: 'JLD verlangt, dass seine Partner die Grundsätze dieses Ethikkodex an ihre Unterlieferanten weitergeben.'
      },
      {
        num: '7',
        title: 'Einhaltung des Kodex',
        text: 'Ein Verstoß gegen die Grundsätze dieses Ethikkodex kann zur Neubewertung der Geschäftsbeziehung mit den Lieferanten von JLD s.r.o., zur Beendigung der Zusammenarbeit und gegebenenfalls zu Schadensersatzforderungen führen.'
      },
      {
        num: '8',
        title: 'Meldung von Verstößen',
        text: 'Geschäftspartner sind verpflichtet, den Verdacht auf Verstöße gegen den Kodex oder gegen gesetzliche Vorschriften einem berechtigten Vertreter von JALUD EMBEDDED, s.r.o. zu melden.'
      }
    ]
  },
  en: {
    title: 'Supplier Code of Ethics',
    eyebrow: 'CORPORATE RESPONSIBILITY & SUSTAINABILITY',
    subtitle: 'Ethical principles and standards for suppliers and business partners of JALUD Embedded s.r.o.',
    pdfBtn: 'Download PDF',
    pdfUrl: '/docs/legal/CODE_of_Ethics.pdf',
    intro: 'JALUD EMBEDDED, s.r.o. (hereinafter JLD) is committed to social and business responsibility with the goal of creating long-term value. As part of this approach, business partners are engaged in the sustainability strategy.',
    sections: [
      {
        num: '1',
        title: 'Treatment of Employees',
        text: 'JLD requires its business partners to comply with legal regulations and standards set by the UN and ILO (International Labour Organization), including the prohibition of child labor, ensuring equal opportunities without discrimination, rejecting slavery and forced labor, respecting trade unions and interest groups, and adhering to legal regulations on wages and working hours.'
      },
      {
        num: '2',
        title: 'Health & Safety',
        text: 'JLD requires suppliers to ensure a safe working environment, comply with occupational health and safety (OHS) regulations, and adopt preventive measures to protect employees\' well-being.'
      },
      {
        num: '3',
        title: 'Environmental Protection',
        text: 'JLD expects business partners to comply with relevant laws and regulations, as well as to use resources efficiently and handle materials safely.'
      },
      {
        num: '4',
        title: 'Business Conduct',
        text: 'JLD promotes zero tolerance for bribery and manipulation and expects the acceptance of gifts and invitations only within reasonable value, decision-making based on objective criteria, compliance with fair competition rules, and cooperation in the fight against money laundering.'
      },
      {
        num: '5',
        title: 'Information Protection',
        text: 'JLD suppliers must protect confidential information and trade secrets, handle personal data in accordance with legal regulations, and use information only for legitimate purposes.'
      },
      {
        num: '6',
        title: 'Supplier Relations',
        text: 'JLD requires its partners to extend the principles of this Code of Ethics to their subcontractors.'
      },
      {
        num: '7',
        title: 'Compliance with the Code',
        text: 'Violations of this Code of Ethics may lead to a review of the business relationship, termination of cooperation, and potential compensation for damages.'
      },
      {
        num: '8',
        title: 'Reporting Violations',
        text: 'Business partners are required to report any suspected violations of this Code or legal regulations to an authorized representative of JALUD EMBEDDED, s.r.o.'
      }
    ]
  },
  es: {
    title: 'Código de Ética para Proveedores',
    eyebrow: 'RESPONSABILIDAD CORPORATIVA Y SOSTENIBILIDAD',
    subtitle: 'Principios éticos y normas para proveedores y socios comerciales de JALUD Embedded s.r.o.',
    pdfBtn: 'Descargar PDF (en inglés)',
    pdfUrl: '/docs/legal/CODE_of_Ethics.pdf',
    intro: 'JALUD EMBEDDED, s.r.o. (en adelante JLD) está comprometida con la responsabilidad social y comercial con el objetivo de generar valor a largo plazo. Como parte de este enfoque, los socios comerciales participan activamente en la estrategia de sostenibilidad.',
    sections: [
      {
        num: '1',
        title: 'Trato a los empleados',
        text: 'JLD exige a sus socios comerciales el cumplimiento de las normativas legales y los estándares de la ONU y la OIT (Organización Internacional del Trabajo), incluida la prohibición del trabajo infantil, la garantía de igualdad de oportunidades sin discriminación, el rechazo de la esclavitud y el trabajo forzoso, el respeto a los sindicatos y grupos de interés, y el cumplimiento de las regulaciones sobre salarios y jornadas laborales.'
      },
      {
        num: '2',
        title: 'Seguridad y salud en el trabajo',
        text: 'JLD exige que los proveedores garanticen un entorno de trabajo seguro, cumplan la legislación de seguridad y salud en el trabajo y adopten medidas preventivas para proteger la salud de sus trabajadores.'
      },
      {
        num: '3',
        title: 'Protección del medio ambiente',
        text: 'JLD espera que sus socios comerciales cumplan las leyes y reglamentos pertinentes, además de hacer un uso eficiente de los recursos y emplear materiales seguros.'
      },
      {
        num: '4',
        title: 'Conducta en el entorno empresarial',
        text: 'JLD promueve la tolerancia cero frente al soborno y la manipulación, y exige que la aceptación de regalos e invitaciones sea únicamente por un valor razonable, que las decisiones se tomen con criterios objetivos, que se respeten las normas de libre competencia y se colabore en la prevención del blanqueo de capitales.'
      },
      {
        num: '5',
        title: 'Protección de la información',
        text: 'Los proveedores de JLD están obligados a proteger la información confidencial y los secretos comerciales, a tratar los datos de carácter personal de conformidad con la legislación aplicable y a utilizar la información únicamente para fines legítimos.'
      },
      {
        num: '6',
        title: 'Relaciones con subproveedores',
        text: 'JLD exige que sus socios transmitan y apliquen los principios de este Código de Ética a sus propios subcontratistas y proveedores.'
      },
      {
        num: '7',
        title: 'Cumplimiento del Código',
        text: 'El incumplimiento de los principios de este Código de Ética puede dar lugar a la revisión de la relación comercial con los proveedores de JLD s.r.o., la rescisión de la cooperación y posibles reclamaciones de indemnización por daños y perjuicios.'
      },
      {
        num: '8',
        title: 'Notificación de infracciones',
        text: 'Los socios comerciales tienen la obligación de comunicar cualquier sospecha de infracción del Código o de la legislación aplicable a un representante autorizado de JALUD EMBEDDED, s.r.o.'
      }
    ]
  },
  pt: {
    title: 'Código de Ética para Fornecedores',
    eyebrow: 'RESPONSABILIDADE CORPORATIVA E SUSTENTABILIDADE',
    subtitle: 'Princípios éticos e diretrizes para fornecedores e parceiros comerciais da JALUD Embedded s.r.o.',
    pdfBtn: 'Baixar PDF (em inglês)',
    pdfUrl: '/docs/legal/CODE_of_Ethics.pdf',
    intro: 'A JALUD EMBEDDED, s.r.o. (doravante JLD) preza pela responsabilidade social e corporativa com o objetivo de gerar valor sustentável a longo prazo. Parte fundamental dessa abordagem é o engajamento dos parceiros comerciais na estratégia de sustentabilidade.',
    sections: [
      {
        num: '1',
        title: 'Tratamento dos colaboradores',
        text: 'A JLD exige de seus parceiros comerciais o cumprimento estrito das disposições legais e das normas da ONU e da OIT (Organização Internacional do Trabalho), vedando o trabalho infantil, garantindo a igualdade de oportunidades sem discriminação, repudiando o trabalho escravo ou forçado, respeitando os sindicatos e entidades de classe, e cumprindo a legislação relativa a salários e jornada de trabalho.'
      },
      {
        num: '2',
        title: 'Segurança e saúde no trabalho',
        text: 'A JLD exige que os fornecedores garantam um ambiente de trabalho seguro, cumpram a legislação de segurança e saúde ocupacional e adotem medidas preventivas eficazes para a proteção da saúde.'
      },
      {
        num: '3',
        title: 'Proteção ambiental',
        text: 'A JLD espera que seus parceiros comerciais cumpram as leis e regulamentos ambientais aplicáveis, além de promover o uso eficiente de recursos e o manuseio de materiais seguros.'
      },
      {
        num: '4',
        title: 'Conduta no ambiente de negócios',
        text: 'A JLD adota tolerância zero contra suborno e manipulação, aceitando presentes e convites somente dentro de valores estritamente razoáveis, fundamentando decisões em critérios objetivos, respeitando as regras da livre concorrência e cooperando no combate à lavagem de dinheiro.'
      },
      {
        num: '5',
        title: 'Proteção de informações',
        text: 'Os fornecedores da JLD são obrigados a proteger informações confidenciais e segredos comerciais, a tratar dados pessoais em total conformidade com a legislação e a utilizar as informações apenas para finalidades autorizadas.'
      },
      {
        num: '6',
        title: 'Relações com subfornecedores',
        text: 'A JLD requer que seus parceiros repassem e exijam a aplicação dos princípios deste Código de Ética aos seus respectivos subcontratados.'
      },
      {
        num: '7',
        title: 'Cumprimento do Código',
        text: 'A violação dos princípios deste Código de Ética poderá acarretar a reavaliação da relação comercial com a JLD s.r.o., a rescisão da cooperação e eventuais reparações por perdas e danos.'
      },
      {
        num: '8',
        title: 'Comunicação de infrações',
        text: 'Os parceiros comerciais têm o dever de reportar qualquer suspeita de violação do Código ou das normas legais a um representante autorizado da JALUD EMBEDDED, s.r.o.'
      }
    ]
  },
  ar: {
    title: 'ميثاق الشرف الأخلاقي للموردين',
    eyebrow: 'المسؤولية المؤسسية والاستدامة',
    subtitle: 'المبادئ والمعايير الأخلاقية للموردين والشركاء التجاريين لشركة JALUD Embedded s.r.o.',
    pdfBtn: 'تحميل ملف PDF (باللغة الإنجليزية)',
    pdfUrl: '/docs/legal/CODE_of_Ethics.pdf',
    intro: 'تلتزم شركة JALUD EMBEDDED, s.r.o. (المشار إليها فيما يلي بـ JLD) بالمسؤولية الاجتماعية والتجارية بهدف خلق قيمة طويلة الأجل. ويشكل إشراك الشركاء التجاريين في استراتيجية الاستدامة جزءاً أساسياً من هذا النهج.',
    sections: [
      {
        num: '1',
        title: 'معاملة الموظفين',
        text: 'تطلب JLD من شركائها التجاريين الامتثال للأنظمة القانونية ومعايير الأمم المتحدة ومنظمة العمل الدولية (ILO)، وحظر تشغيل الأطفال، وضمان تكافؤ الفرص دون تمييز، ورفض السخرة والعمل القسري، واحترام النقابات ومجموعات المصالح، والالتزام بالقوانين المنظمة للأجور وساعات العمل.'
      },
      {
        num: '2',
        title: 'السلامة والصحة المهنية',
        text: 'تطلب JLD من الموردين توفير بيئة عمل آمنة، والامتثال للتشريعات المنظمة للصحة والسلامة المهنية، واتخاذ تدابير وقائية لحماية الصحة.'
      },
      {
        num: '3',
        title: 'حماية البيئة',
        text: 'تتوقع JLD من شركائها التجاريين الالتزام بجميع القوانين واللوائح المعمول بها، بالإضافة إلى الاستخدام الفعال للموارد والمواد الآمنة.'
      },
      {
        num: '4',
        title: 'السلوك في بيئة الأعمال',
        text: 'تنتهج JLD سياسة عدم التسامح مطلقاً مع الرشوة والتلاعب، وتقتصر على قبول الهدايا والدعوات ذات القيمة المعقولة فقط، واتخاذ القرارات بناءً على معايير موضوعية، والالتزام بقواعد المنافسة العادلة، والتعاون الفعال في مكافحة غسيل الأموال.'
      },
      {
        num: '5',
        title: 'حماية المعلومات',
        text: 'يلتزم موردو JLD بحماية المعلومات السرية والأسرار التجارية، ومعالجة البيانات الشخصية بما يتوافق مع الأنظمة القانونية، واستخدام المعلومات للأغراض المصرح بها فقط.'
      },
      {
        num: '6',
        title: 'العلاقات مع الموردين من الباطن',
        text: 'تطلب JLD من شركائها نقل مبادئ هذا الميثاق الأخلاقي وفرضها على مقاوليهم ومورديهم من الباطن.'
      },
      {
        num: '7',
        title: 'الامتثال للميثاق',
        text: 'قد يؤدي انتهاك مبادئ هذا الميثاق الأخلاقي إلى مراجعة العلاقة التجارية مع موردي JLD s.r.o.، وإنهاء التعاون، والمطالبة بالتعويض عن الأضرار إن وجدت.'
      },
      {
        num: '8',
        title: 'الإبلاغ عن الانتهاكات',
        text: 'يتعين على الشركاء التجاريين إبلاغ الممثل المعتمد لشركة JALUD EMBEDDED, s.r.o. عن أي اشتباه في انتهاك الميثاق أو القوانين المعمول بها.'
      }
    ]
  }
};

export function renderCodeOfEthicsPage(onNavigate) {
  const container = document.createElement('div');
  container.className = 'sed-page';
  const lang = getLocale() || 'en';
  const data = ethicsData[lang] || ethicsData.en;
  const isRtl = lang === 'ar';

  container.innerHTML = `
    <section class="sed-section" style="background: linear-gradient(165deg, var(--blue-light) 0%, #ffffff 70%); padding: 4.5rem 0 3rem; direction: ${isRtl ? 'rtl' : 'ltr'}; text-align: ${isRtl ? 'right' : 'left'};">
      <div class="sed-container">
        <div class="sed-section-header" style="max-width: 860px; margin-bottom: 2rem; margin-left: ${isRtl ? 'auto' : '0'}; margin-right: ${isRtl ? '0' : 'auto'};">
          <div class="sed-eyebrow">${data.eyebrow}</div>
          <h1 class="sed-page-hero-title">${data.title}</h1>
          <p class="sed-section-desc">${data.subtitle}</p>
        </div>
      </div>
    </section>

    <section class="sed-section" style="background-color: #ffffff; padding: 2rem 0 5rem; direction: ${isRtl ? 'rtl' : 'ltr'}; text-align: ${isRtl ? 'right' : 'left'};">
      <div class="sed-container" style="max-width: 900px;">
        <div class="sed-card" style="padding: 2.75rem; line-height: 1.8; color: var(--text-dark); border: 1.5px solid var(--slate-line); border-radius: 16px; box-shadow: 0 4px 20px rgba(0,0,0,0.03);">
          
          <!-- Download Button Action Bar (No fake document IDs or dates) -->
          <div style="display: flex; justify-content: space-between; align-items: center; border-bottom: 2px solid var(--blue-light); padding-bottom: 1.25rem; margin-bottom: 2rem; flex-wrap: wrap; gap: 1rem;">
            <div>
              <span style="font-weight: 800; color: var(--navy-dark); font-size: 1.15rem; font-family: var(--font-heading);">
                JALUD Embedded s.r.o.
              </span>
            </div>
            <a href="${data.pdfUrl}" target="_blank" rel="noopener noreferrer" class="sed-btn sed-btn-outline" style="font-size: 0.9rem; color: var(--blue-primary); border-color: var(--blue-primary); font-weight: 700; display: inline-flex; align-items: center; gap: 8px;">
              <span>📥</span>
              <span>${data.pdfBtn}</span>
            </a>
          </div>

          <!-- Preamble / Intro Paragraph -->
          <div style="background: #f8fafc; border-left: ${isRtl ? 'none' : '4px solid var(--blue-primary)'}; border-right: ${isRtl ? '4px solid var(--blue-primary)' : 'none'}; padding: 1.25rem 1.5rem; border-radius: ${isRtl ? '8px 0 0 8px' : '0 8px 8px 0'}; margin-bottom: 2.5rem; font-size: 1.05rem; color: var(--navy-dark); font-weight: 600; line-height: 1.7;">
            ${data.intro}
          </div>

          <!-- The 8 Defined Sections -->
          <div style="display: flex; flex-direction: column; gap: 2rem;">
            ${data.sections.map(sec => `
              <div style="border-bottom: 1px solid var(--slate-line); padding-bottom: 1.5rem;">
                <h3 style="font-family: var(--font-heading); font-size: 1.25rem; font-weight: 800; color: var(--navy-dark); margin-bottom: 0.65rem; display: flex; align-items: center; gap: 10px;">
                  <span style="background: var(--blue-ultra-light); color: var(--blue-primary); width: 30px; height: 30px; border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; font-size: 0.9rem; font-weight: 800; flex-shrink: 0;">
                    ${sec.num}
                  </span>
                  <span>${sec.title}</span>
                </h3>
                <p style="margin: 0; font-size: 1.02rem; line-height: 1.75; color: var(--text-dark);">
                  ${sec.text}
                </p>
              </div>
            `).join('')}
          </div>

        </div>
      </div>
    </section>
  `;

  return container;
}
